<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Leave Application Form</h3>
           </template>
           <div class="row">
             <div class="col-md-6">
              <nav>
                 <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                       <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                       <router-link to="/hr/absenceleave">Leave & Absences Record</router-link>
                    </li>
                    <li class="breadcrumb-item active">Leave Application Form</li>
                 </ol>
              </nav>
              </div>
              <div class="col-md-6" style="margin-top:-45px">
                  <span class="float-right">
                    <h2>
                        <slot v-if="emp != ''">
                            <span class="badge badge-pill badge-danger">
                                {{credits_indicator.leave_credit_balance}}
                             </span>
                             Leave Credits 
                        </slot>
                    </h2>
                  </span> 
              </div> 
           </div>
           <hr style="margin-top:-10px"/>
           <form @submit="formSubmit">
              <div class="row">
                 <div class="col-md-12">
                    <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Employee Leave Form</font>         
                    <div class="border-box-leave">
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group"> 
                                <label>Date Filled  :</label>
                                <input type="date" v-model="date_filled" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_filled}">
                                <span v-if="error_handler.date_filled" class="invalid-feedback">{{ error_handler.date_filled[0] }}</span>
                             </div>
                             <div class="form-group">
                                <label>Employee Name / Employee ID:</label>
                                <select class="form-control" v-model="emp" v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id}" @change="indicator_leave">
                                   <option value="">-- Please select one --</option>
                                   <option v-for="emp in items" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
                                </select>
                                <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
                             </div>
                             <div class="form-group">
                                <label>Number of Days Leave :</label>
                                <input v-model="countBusiness" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.no_of_days}" readonly>
                                <span v-if="error_handler.no_of_days" class="invalid-feedback">{{ error_handler.no_of_days[0] }}</span>
                             </div>
                             <div class="form-group">
                                <label>Type Of Leave : </label>
                                <select class="form-control" v-model="leave_type" v-bind:class="{ 'is-invalid': error_handler && error_handler.leave_type}">
                                   <option value="">-- Please select one --</option>
                                   <option value="Vacation">Vacation Leave</option>
                                   <option value="Medical/Sick">Medical/Sick Leave</option>
                                   <option value="Emergency">Emergency Leave</option>
                                   <option value="Maternity">Maternity Leave</option>
                                   <option value="Paternity">Paternity Leave</option>
                                   <option value="Bereavement Leave">Bereavement Leave</option>
                                   <option value="Offset">Offset</option>
                                </select>
                                <span v-if="error_handler.leave_type" class="invalid-feedback">{{ error_handler.leave_type[0] }}</span> 
                             </div>
                             <div class="form-group">
                                <label>Remarks : </label>
                                <select class="form-control" v-model="remarks" v-bind:class="{ 'is-invalid': error_handler && error_handler.remarks}">
                                   <option disabled value="">-- Please select one --</option>
                                   <option value="With Pay">With Pay</option>
                                   <option value="Without Pay">Without Pay</option>
                                </select>
                                <span v-if="error_handler.remarks" class="invalid-feedback">{{ error_handler.remarks[0] }}</span> 
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group"> 
                                <label>Start Date  :</label>
                                <input type="date" v-model="start_date" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.start_date}">
                                <span v-if="error_handler.start_date" class="invalid-feedback">{{ error_handler.start_date[0] }}</span> 
                             </div>
                             <div class="form-group"> 
                                <label>End Date  :</label>
                                <input type="date" v-model="end_date" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.end_date}">
                                <span v-if="error_handler.end_date" class="invalid-feedback">{{ error_handler.end_date[0] }}</span>
                             </div>
                             <div class="form-group">
                                <label>Reason for Leave / Absent : </label>
                                <textarea rows="8" v-model="reason" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.reason}"></textarea>
                                <span v-if="error_handler.reason" class="invalid-feedback">{{ error_handler.reason[0] }}</span> 
                             </div>
                          </div>
                       </div>
                    </div>
                    <br/> <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Approval Status</font>  
                    <div class="border-box-leave">
                       <div class="row">
                          <div class="col-md-4">
                             <label>Supervisor Approval</label>
                             <select class="form-control" v-model="tl_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_status}">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                             <span v-if="error_handler.status" class="invalid-feedback">{{ error_handler.tl_status[0] }}</span>  
                          </div>
                          <div class="col-md-4">
                             <label>Departamental Head Approval</label>
                             <select class="form-control" v-model="asm_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_status}">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                             <span v-if="error_handler.asm_status" class="invalid-feedback">{{ error_handler.asm_status[0] }}</span>  
                          </div>
                          <div class="col-md-4">
                             <label>HR Department Approval</label>
                             <select class="form-control" v-model="status"  v-bind:class="{ 'is-invalid': error_handler && error_handler.status}">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                             <span v-if="error_handler.status" class="invalid-feedback">{{ error_handler.status[0] }}</span>  
                          </div>
                       </div>
                       <hr/>
                       <div class="row">
                          <div class="col-md-4">
                             <label>Supervisor Date Approval</label>
                             <div class="form-group">
                                <input type="date" v-model="tl_date_approved" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_date_approved}">
                                <span v-if="error_handler.tl_date_approved" class="invalid-feedback">{{ error_handler.tl_date_approved[0] }}</span>  
                             </div>
                          </div>
                          <div class="col-md-4">
                             <label>Departamental Head Date Approval</label>
                             <div class="form-group">
                                <input type="date"  v-model="asm_date_approved" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_date_approved}">
                                <span v-if="error_handler.asm_date_approved" class="invalid-feedback">{{ error_handler.asm_date_approved[0] }}</span>  
                             </div>
                          </div>
                          <div class="col-md-4">
                             <label>HR Date Approval</label>
                             <div class="form-group">
                                <input type="date" v-model="hr_date_approved" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_date_approved}">
                                <span v-if="error_handler.hr_date_approved" class="invalid-feedback">{{ error_handler.hr_date_approved[0] }}</span>  
                             </div>
                          </div>
                       </div>
                    </div>
                    <div class="form-group">
                       <div class="float-right">  
                          <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button> <br/><br/>
                       </div>
                    </div>
                    <br/> <br/>
                 </div>
              </div>
           </form>
        </card>
     </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      emp: "",
      no_of_days: "",
      date_filled: "",
      leave_type: "",
      remarks: "",
      start_date: "",
      end_date: "",
      reason: "",
      status: "",
      tl_status: "",
      asm_status: "",
      //date approval
      tl_date_approved: "",
      asm_date_approved: "",
      hr_date_approved: "",
      // Errors handler
      error_handler: [],
      no_credits:'',
      //credits
       credits_indicator:'',
      //loading
      loading:true 
    };
  },
  mounted: function() {
    this.get_employees();
    this.indicator_leave();
   setTimeout(() => {
           this.loading = false;
        }, 300); 
  },
  methods: {

    indicator_leave(){
           axios
               .get('api/employee/credits/' + this.emp)
               .then(resp => {
                     this.credits_indicator = resp.data
               })
               .catch(error => {
                    console.log(error)
               })
    },
 
    get_employees() {
      axios
        .get("api/employees")
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formSubmit(e) {
      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(isConfirm => {
        if (isConfirm === true) {
          axios
            .post(
              "api/manualleave/add",
              {
                employee_id: this.emp,
                date_filled: this.date_filled,
                no_of_days: this.no_of_days,
                leave_type: this.leave_type,
                remarks: this.remarks,
                start_date: this.start_date,
                end_date: this.end_date,
                reason: this.reason,
                status: this.status,
                tl_status: this.tl_status,
                asm_status: this.asm_status,
                tl_date_approved: this.tl_date_approved,
                asm_date_approved: this.asm_date_approved,
                hr_date_approved: this.hr_date_approved
              }
            )
            .then(resp => {
              this.$swal("Save", "You successfully save this file", "success");
              this.$router.push({ name: "absence-leave" });
              this.resForm();
            })
            .catch(error => {
                  if (error.response.status == 422){
                        this.error_handler = error.response.data.errors 
                        this.no_credits = error.response.data.message
                        this.$swal('Opps', this.no_credits, 'error');

                        this.no_of_days = ''
                    }
                }); 
        }
      });
    }
  },
  computed:{  

           countBusiness(){
                  this.no_of_days = moment(this.start_date, 'MM-DD-YYYY').businessDiff(moment(this.end_date,'MM-DD-YYYY'));
                 return this.no_of_days 
          },


  countDate:{
          get(){
              
              let start = moment(this.start_date)
              let end = moment(this.end_date)
              this.no_of_days = end.diff(start, "days") + 1
              //if NaN result change to 0
              if (isNaN(this.no_of_days )) this.no_of_days  = 0;
              return  this.no_of_days
          },

          set(val){
               this.no_of_days = val
          }
          
      }



  },
 
};
</script>
<style>
         .border-box-leave{
                 border: 1px dashed #666;
                 width: 100%;
                 padding: 20px;
             }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-request-leave.vue